<!--
 * @Author: yihao yihao@meiomedical.com
 * @Date: 2025-08-19 14:17:57
 * @LastEditors: yihao yihao@meiomedical.com
 * @LastEditTime: 2025-10-28 14:25:03
 * @FilePath: \website_vue1\src\views\medical.vue
-->
<template>
  <div>
    <!-- 固定头部导航 -->
    <!-- <nav class="anchor-navbar" ref="anchorNavbar">
      <ul class="anchor-list">
     
        <li class="display-only">{{ sections[0].label }}</li>

       
        <li
          v-for="(item, index) in sections.slice(1)"
          :key="index + 1"
          :class="{ active: activeSection === item.id }"
          @click="scrollToSection(item,index)"
        >{{ item.label }}</li>
      </ul>
    </nav>-->

    <!-- 视频首屏 -->
    <section class="video" ref="videoSection">
      <video autoplay muted loop playsinline class="bg-video" ref="bgVideo" :src="videoSrc" poster="../assets/images/clinical/videoBg.jpg"></video>

      <!-- 遮罩层 -->
      <div class="video-overlay"></div>

      <div class="video-text" ref="videoText">
        <h2 class="video-text-header">{{ $t('message.clinicalVideoTitle') }}</h2>
        <p class="video-text-desc">{{ $t('message.clinicalVideoHint') }}</p>
      </div>
    </section>

    <!-- 临床试验-主要有效性评价 -->
    <section class="clinical-results" id="clinical-results-bg1" ref="clinicalSection1">
      <div class="title">
        <div class="title-header">{{ $t('message.clinicalEvaluateEffe.evaluateTitle') }}</div>
        <div style="color: #adafaf;font-size: 1.2rem;line-height: 1.7rem;font-weight: 400;" v-if="!isMobile">
          <div>{{ $t('message.clinicalEvaluateEffe.evaluateHint') }}</div>

          <div>{{ $t('message.clinicalEvaluateEffe.evaluateHint1') }}</div>
        </div>
        <div
          v-if="isMobile"
          class="mobileText"
        >{{ $t('message.clinicalEvaluateEffe.evaluateHint') }}{{ $t('message.clinicalEvaluateEffe.evaluateHint1') }}</div>
      </div>

      <div class="card-container-efficacy">
        <div class="card-container-efficacy-data">
          <!-- 卡片2 -->
          <div class="result-card">
            <h3>{{ $t('message.clinicalEvaluateEffe.item01Title') }}</h3>
            <div class="card-content">
              <div class="group">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateEffe.item01GroupType') }}</div>
                </div>
                <p
                  style="font-size: var(--subThirdtitle-font-size);font-weight: bolder;"
                >{{ $t('message.clinicalEvaluateEffe.item01TrialGroup') }}</p>
                <p>{{ $t('message.clinicalEvaluateEffe.item01ControlGroup') }}</p>
              </div>
              <div class="value">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateEffe.item01Amount') }}</div>
                </div>

                <p class="highlight">89</p>
                <p>95</p>
              </div>
              <div class="rate">
                <div>
                  <div style="width:100%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateEffe.item01Rate') }}</div>
                </div>

                <p class="highlight success">
                  <span>100%</span>
                  <span style="font-size: var(--subThirdtitle-font-size) !important;margin-left: 5px;">(89/89)</span>
                </p>
                <p>100% (95/95)</p>
              </div>
            </div>
          </div>

          <!-- 卡片4 -->
          <div class="result-card">
            <h3>{{ $t('message.clinicalEvaluateEffe.item02Title') }}</h3>
            <div class="card-content">
              <div class="group">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateEffe.item02GroupType') }}</div>
                </div>

                <p
                  style="font-size: var(--subThirdtitle-font-size);font-weight: bolder;"
                >{{ $t('message.clinicalEvaluateEffe.item02TrialGroup') }}</p>
                <p>{{ $t('message.clinicalEvaluateEffe.item02ControlGroup') }}</p>
              </div>
              <div class="value">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateEffe.item02Amount') }}</div>
                </div>
                <!-- <p style="background-color: #F9F9F9;">数量</p> -->
                <p class="highlight">89</p>
                <p>95</p>
              </div>
              <div class="rate">
                <div>
                  <div style="width:100%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateEffe.item02Rate') }}</div>
                </div>
                <!-- <p style="background-color: #F9F9F9;">发生率</p> -->
                <p class="highlight success">
                  <span>5.62%</span>
                  <span style="font-size: var(--subThirdtitle-font-size)!important;margin-left: 5px;">(5/89)</span>
                </p>
                <p>7.37% (7/95)</p>
              </div>
            </div>
          </div>
        </div>
        <div class="image-wrapper">
          <img src="../assets/images/clinical/efficacy.png" />
        </div>
      </div>
    </section>

    <!-- 临床试验-主要安全性评价 -->
    <section class="clinical-results" id="clinical-results-bg2" ref="clinicalSection2">
      <div class="title">
        <div class="title-header">{{ $t('message.clinicalEvaluateSafe.evaluateTitle') }}</div>
        <div style="color: black;font-size: 1.2rem;line-height: 1.7rem;font-weight: 400;" v-if="!isMobile">
          <div>{{ $t('message.clinicalEvaluateSafe.evaluateHint') }}</div>
          <div>{{ $t('message.clinicalEvaluateSafe.evaluateHint1') }}</div>
        </div>
        <div v-if="isMobile" class="mobileText" style="color:#3d3d3d">
          <div>{{ $t('message.clinicalEvaluateSafe.evaluateHint') }}{{ $t('message.clinicalEvaluateSafe.evaluateHint1') }}</div>
        </div>
      </div>
      <div class="card-container-efficacy">
        <div class="card-container-efficacy-data">
          <!-- 卡片1 -->
          <div class="result-card">
            <h3>{{ $t('message.clinicalEvaluateSafe.item01Title') }}</h3>
            <div class="card-content">
              <div class="group">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateSafe.item01GroupType') }}</div>
                </div>
                <!-- <p style="background-color: #F9F9F9;">人群</p> -->
                <p
                  style="font-size: var(--subThirdtitle-font-size);font-weight: bolder;"
                >{{ $t('message.clinicalEvaluateSafe.item01TrialGroup') }}</p>
                <p>{{ $t('message.clinicalEvaluateSafe.item01ControlGroup') }}</p>
              </div>
              <div class="value">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateSafe.item01Amount') }}</div>
                </div>
                <!-- <p style="background-color: #F9F9F9;">数量</p> -->
                <p class="highlight">89</p>
                <p>95</p>
              </div>
              <div class="rate">
                <div>
                  <div style="width:100%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateSafe.item01Rate') }}</div>
                </div>
                <!-- <p style="background-color: #F9F9F9;">术中并发症发生率</p> -->
                <p class="highlight success">
                  <span>0.00%</span>
                  <span style="font-size: var(--subThirdtitle-font-size) !important;margin-left: 5px;">(0/89)</span>
                </p>
                <p>0.00% (0/95)</p>
              </div>
            </div>
          </div>

          <!-- 卡片3 -->
          <div class="result-card">
            <h3>{{ $t('message.clinicalEvaluateSafe.item02Title') }}</h3>
            <div class="card-content">
              <div class="group">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateSafe.item02GroupType') }}</div>
                </div>
                <p
                  style="font-size: var(--subThirdtitle-font-size);font-weight: bolder;"
                >{{ $t('message.clinicalEvaluateSafe.item02TrialGroup') }}</p>
                <p>{{ $t('message.clinicalEvaluateSafe.item02ControlGroup') }}</p>
              </div>
              <div class="value">
                <div>
                  <div style="width:85%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateSafe.item02Amount') }}</div>
                </div>

                <p class="highlight">89</p>
                <p>95</p>
              </div>
              <div class="rate">
                <div>
                  <div style="width:100%;background-color: #F9F9F9">{{ $t('message.clinicalEvaluateSafe.item02Rate') }}</div>
                </div>
                <!-- <p style="background-color: #F9F9F9;">术后并发症发生率</p> -->
                <p class="highlight success">
                  <span>0.00%</span>
                  <span style="font-size:var(--subThirdtitle-font-size) !important;margin-left: 5px;">(0/89)</span>
                </p>
                <p>1.00% (1/95)</p>
              </div>
            </div>
          </div>
        </div>
        <div class="image-wrapper">
          <img src="../assets/images/clinical/safety.png" />
        </div>
      </div>
    </section>

    <!-- 专家认可 -->

    <section class="expert-section" ref="clinicalSection3">
      <div class="expert-title">{{ $t('message.clinicalExpertTitle') }}</div>
      <!-- <h2 class="section-title">顶级心脏中心专家临床认可</h2> -->

      <div class="content-wrapper">
        <!-- 左侧医院 Logo 列表 -->
        <!-- <div class="logo-list" ref="logoList">
          <div class="logo-item" v-for="(logo, index) in logos" :key="index" :class="{ 'single-row': logo.name === '首都医科大学附属北京安贞医院' }">
            <img :src="logo.src" :alt="logo.name" />
            <p>{{ logo.name }}</p>
          </div>
        </div>-->
        <div class="expert-image">
          <video controls :src="videoSrc1" class="expert-video" ref="expertVideo"></video>

          <!-- <img src="../assets/images/clinical/expert.png" /> -->
        </div>

        <div class="expert-reviews">
          <div>
            <img class="expert-reviews-image" src="../assets/images/clinical/expert-quote1.png" />
          </div>
          <div class="expert-reviews-text">{{ $t('message.clinicalExpertContent') }}</div>

          <div class="expert-reviews-quote2">
            <img class="expert-reviews-image" src="../assets/images/clinical/expert-quote2.png" />
          </div>

          <div class="famous-doctor">
            <div class="famous-doctor-text">
              <div style="font-weight: bolder;">{{ $t('message.clinicalExpertName') }}</div>
              <div style="font-size: 1.3rem;font-weight: 600;">马长生教授</div>
              <div style="margin-top: 1.2rem;" class="clinicalIntroduceText">{{ $t('message.clinicalExpertIntro') }}</div>
              <div class="clinicalIntroduceText">{{ $t('message.clinicalExpertIntro1') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      images: [
        {
          src: require('@/assets/images/clinical/example.png'),
          caption: '床旁机械手替代人手握持压力感应导管及管，并进行推进及旋转，打弯操作'
        },
        {
          src: require('@/assets/images/clinical/example1.png'),
          caption: '机器人消融顶部-压力稳定可控，压力波动1-2g内'
        },
        {
          src: require('@/assets/images/clinical/example2.png'),
          caption: '机器人消融背部-贴靠稳定，适量指向准确'
        }
      ],
      videoSrc: require('@/assets/videos/clinical2.mp4'),
      videoSrc1: require('@/assets/videos/doctorSay.mp4'),
      lastScrollY: 0,
      scrollDirection: null,
      lastScrollTime: 0,
      sections: [
        { label: this.$t('message.clinicalEvaluateTitleBtn'), content: '展示内容', id: 0 },
        { label: this.$t('message.clinicalEvaluateEffeBtn'), content: '展示内容', id: 1 },
        { label: this.$t('message.clinicalEvaluateSafetyBtn'), content: '展示内容', id: 2 },
        { label: this.$t('message.clinicalEvaluateExpertBtn'), content: '展示内容', id: 3 }
      ],
      activeSection: 0,
      isManualScroll: true,
      wrapperTop: 0,
      wrapperHeight: 0,
      logos: [
        { name: '首都医科大学附属北京安贞医院', src: require('@/assets/images/clinical/hospital.png') },
        { name: '上海市第一人民医院', src: require('@/assets/images/clinical/hospital1.png') },
        { name: '浙江大学附属邵逸夫医院', src: require('@/assets/images/clinical/hospital2.png') },
        { name: '四川大学华西医院', src: require('@/assets/images/clinical/hospital3.png') },
        { name: '温州医科大学附属第一医院', src: require('@/assets/images/clinical/hospital4.png') },
        { name: '天津医科大学总医院', src: require('@/assets/images/clinical/hospital5.png') },
        { name: '广东省人民医院', src: require('@/assets/images/clinical/hospital6.png') }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      const wrapper = Array.isArray(this.$refs.wrapper) ? this.$refs.wrapper[0] : this.$refs.wrapper
      if (wrapper) {
        this.wrapperTop = wrapper.offsetTop
        this.wrapperHeight = wrapper.offsetHeight
      }
      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onResize)

      this.setAnchorOffset()
      this.setVideoHeight()

      this.initVideoTextAnimation()
      this.initClinicalResultsAnimation()
      this.initClinicalSafetyAnimation()
      this.initExpertSectionAnimation()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    initExpertSectionAnimation() {
      this.$nextTick(() => {
        const section = this.$refs.clinicalSection3
        if (!section) return

        // 所有需要动画的元素
        const items = section.querySelectorAll('.expert-title, .expert-image, .expert-reviews, .famous-doctor')

        // 初始状态：下移 + 透明
        gsap.set(items, { y: 50, opacity: 0 })

        // 时间线
        const tl = gsap.timeline({ paused: true })
        tl.to(items, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.15 // 依次出现
        })

        // IntersectionObserver 可重复触发
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
            } else {
              // 滑出视口时复位，可再次触发
              gsap.set(items, { y: 50, opacity: 0 })
              tl.pause(0)
            }
          },
          { threshold: 0.2 }
        )

        observer.observe(section)
      })
    },

    initClinicalSafetyAnimation() {
      this.$nextTick(() => {
        const section = this.$refs.clinicalSection2
        if (!section) return

        // 所有要动画的元素：标题、描述、卡片、图片
        const items = section.querySelectorAll('.title-header, .title div, .result-card, .image-wrapper')

        // 初始状态：下移 + 透明
        gsap.set(items, { y: 50, opacity: 0 })

        // 时间线
        const tl = gsap.timeline({ paused: true })
        tl.to(items, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.15 // 依次出现
        })

        // IntersectionObserver 可重复触发
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
            } else {
              // 滑出视口时复位，可再次触发
              gsap.set(items, { y: 50, opacity: 0 })
              tl.pause(0)
            }
          },
          { threshold: 0.2 }
        )

        observer.observe(section)
      })
    },

    initClinicalResultsAnimation() {
      this.$nextTick(() => {
        const section = this.$refs.clinicalSection1
        if (!section) return

        // 所有要动画的元素
        const items = section.querySelectorAll('.title-header, .title div, .result-card, .image-wrapper')

        // 初始状态：下移 + 透明
        gsap.set(items, { y: 50, opacity: 0 })

        // 时间线
        const tl = gsap.timeline({ paused: true })
        tl.to(items, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.15 // 依次淡入
        })

        // 滚动监听，可重复触发
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
            } else {
              // 滑出时复位，可再次触发
              gsap.set(items, { y: 50, opacity: 0 })
              tl.pause(0)
            }
          },
          { threshold: 0.2 }
        )

        observer.observe(section)
      })
    },

    initVideoTextAnimation() {
      this.$nextTick(() => {
        const container = this.$refs.videoText
        if (!container) return

        const items = container.querySelectorAll('.video-text-header, .video-text-desc')

        // 初始状态：下移 + 透明
        gsap.set(items, { y: 50, opacity: 0 })

        const tl = gsap.timeline({ paused: true })
        tl.to(items, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.15
        })

        // 滚动监听，可重复触发
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              tl.play()
            } else {
              // 滚出视口时恢复初始状态，可再次触发
              gsap.set(items, { y: 50, opacity: 0 })
              tl.pause(0)
            }
          },
          { threshold: 0.2 }
        )

        observer.observe(container)
      })
    },

    scrollToSection(item) {
      const sectionEl = this.$refs[`clinicalSection${item.id}`]
      if (sectionEl) {
        const navbarHeight = this.$refs.anchorNavbar.offsetHeight || 55 // 固定导航条高度
        const sectionTop = sectionEl.getBoundingClientRect().top + window.scrollY
        const offsetTop = sectionTop - navbarHeight // 减去导航条高度

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })

        this.activeSection = item.id
      }
    },
    onScroll() {
      const scrollY = window.scrollY
      const navbarHeight = this.$refs.anchorNavbar?.offsetHeight || 55

      const section1Top = this.$refs.clinicalSection1?.offsetTop - 65 || 0
      const section2Top = this.$refs.clinicalSection2?.offsetTop - 65 || 0
      const section3Top = this.$refs.clinicalSection3?.offsetTop - 65 || 0

      const offsets = [section1Top, section2Top, section3Top]

      // 如果还在首屏视频区域，不高亮任何导航
      if (scrollY + navbarHeight < section1Top) {
        this.activeSection = null
        return
      }

      // 进入对应区间时高亮
      const current = offsets.findIndex((offset, i) => {
        const nextOffset = offsets[i + 1] ?? Number.MAX_VALUE
        return scrollY + navbarHeight >= offset && scrollY + navbarHeight < nextOffset
      })

      if (current >= 0) {
        this.activeSection = current + 1
      }
    },

    setVideoHeight() {
      const logoHeight = this.$refs.logoList?.offsetHeight
      const videoEl = this.$refs.expertVideo
      if (!logoHeight || !videoEl) return // 直接返回，避免报错
      videoEl.style.height = logoHeight - 140 + 'px'
    },
    setAnchorOffset() {
      const logoEl = document.querySelector('.navbar-logo')
      const navbar = document.querySelector('.navbar')
      if (logoEl && navbar) {
        // const rect = logoEl.getBoundingClientRect()
        // this.$refs.anchorNavbar.style.paddingLeft = rect.left - 20 + 'px'
        // this.$refs.anchorNavbar.style.top = navbar.offsetHeight + 'px'
        // this.$refs.videoSection.style.marginTop = navbar.offsetHeight + logoEl.offsetHeight + 10 + 'px'
        //  this.$refs.videoText.style.top=(navbar.offsetHeight)*-1+'px'
      }
      const containers = this.$el.querySelectorAll('.card-container-efficacy')
      this.isMobile = window.innerWidth <= 768
      containers.forEach(container => {
        const left = container.querySelector('.card-container-efficacy-data')
        const img = container.querySelector('.image-wrapper img')
        if (left && img) {
          img.style.height = left.offsetHeight + 'px'
        }
      })
    },
    onResize() {
      this.$nextTick(() => {
        this.setVideoHeight()
        this.setAnchorOffset()
      })
    }
  }
}
</script>


<style lang="css" scoped>
.mobileText {
  color: #adafaf;
  font-size: 1.2rem;
  line-height: 1.7rem;
  font-weight: 400;
  margin: 0px 20px;
  text-align: left;
}
.clinicalIntroduceText {
  font-size: 1.2rem;
}
.expert-reviews-image {
  width: 3.125rem;
  height: 3.125rem;
}
.expert-reviews-text {
  font-size: 1.2rem;
  line-height: 1.7rem;
  color: #adafaf;
}
.famous-doctor-text {
  position: relative;
  left: 1vw;
  top: 1rem;
  width: 90%;
  line-height: 1.7rem;
}
.title-header {
  font-size: var(--title-font-size);
  font-weight: bolder;
  margin-bottom: 1.9rem;
}
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* 黑色半透明遮罩，可调整透明度 */
  z-index: 1;
}

.single-row-p {
  margin-left: 1.25rem !important;
}
.group {
  border-right: 1px solid #dfdddd;
}
.value {
  border-right: 1px solid #dfdddd;
}
.group-name {
  width: 90%;
  background: #f9f9f9;
  padding: 5px;
  color: #71777a;
}
.word-bg {
  background: url(~@/assets/images/clinical/wordBg.png); /* ~@ 会被解析为 src/ */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: var(--subtitle-font-size);
  padding: 1.25rem;
  text-align: left;
}
.anchor-navbar {
  position: fixed;
  /* top: 3.75rem; */
  width: 100%;
  height: 55px;
  background-color: #111827;
  display: flex;
  align-items: center;
  z-index: 3;
  font-size: var(--header-size);
}
.anchor-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
.anchor-list li {
  margin: 0 2rem;
  color: #9ca3af;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s, border-bottom 0.3s;
  padding-bottom: 4px;
  position: relative;
}
.anchor-list li:hover {
  color: #00acf8;
}
.anchor-list li::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #00acf8;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s;
}
.anchor-list li:hover::after {
  transform: scaleX(1);
}
.anchor-list li.display-only {
  cursor: default;
  color: #f9fafb;
}
.anchor-list li.display-only::after {
  display: none;
}
.anchor-list li.active {
  color: #00acf8;
}
.anchor-list li.active::after {
  transform: scaleX(1);
}

.anchor-section {
  padding-top: 5rem;
  text-align: center;
}

.app {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #fff;
  background: #000;
  overflow-x: hidden;
}

.video {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  text-align: center;
  padding: 0;
}
.bg-video {
  position: absolute;
  width: 100%;
  height: 100%;
  /* max-width: 253.75rem;
  max-height: 1440px; */
  object-fit: cover;
  z-index: -1;
  object-position: center center;
}
.video-text {
  position: relative;
  color: white;
  text-align: center;
  z-index: 10;
  /* top: -5rem; */
}

#clinical-results-bg1 {
  background: #1d1d1d;
}

#clinical-results-bg2 {
  background: #f5f8fa;
}

.clinical-results {
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.title {
  text-align: center;
  color: #00acf8;
  margin-bottom: 8rem;
  width: 64vw;
}
.card-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2.5rem; /* 间隔大一点 */
  width: 85%;
}

.card-container-efficacy {
  display: flex;
  justify-content: center;
  align-items: stretch; /* 关键：左右等高 */
  gap: var(--title-font-size);
  width: 100rem;
  /* padding-bottom: 5rem; */
}

.card-container-efficacy-data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2.5rem;
  flex: 1; /* 左侧占 1 */
}

.image-wrapper {
  flex: 1; /* 或按需求设置宽度，比如 width: 45%; */
  display: flex;
}

.image-wrapper img {
  width: 100%; /* 保持比例 */

  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.result-card {
  background: #fff;
  border-radius: 14px;
  padding: 3.2rem 2.2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}
.result-card h3 {
  font-size: 1.2rem;
  margin-top: 0;
  margin-bottom: 5px;

  /* 关键：固定高度 */
  min-height: 48px; /* 根据你的设计调整，比如两行字的高度 */
  /* 控制溢出显示 */
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 最多显示 2 行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1vw;
}
.group p,
.value p,
.rate p {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  font-size: var(--subtitle-font-size);
}
.highlight {
  font-size: var(--highlight-text-font-size) !important;
  font-weight: bold;
  color: #00a8e3;
}
.success {
  color: #009e15;
}
.warning {
  color: #f39c12;
}

.expert-section {
  background-color: #1d1d1d;
  text-align: center;
  padding-top: 8rem;
  padding-bottom: 7.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.expert-title {
  text-align: center;
  font-size: var(--title-font-size);
  font-weight: bolder;
  color: #00acf8;

  padding-bottom: 8rem;
  width: 65vw;
  margin: 0 auto;
  /* margin-bottom: 5rem;
  margin-top: 65px; */
}

.section-title {
  font-size: 24px;
  color: #00acf8;
  margin-bottom: 2.5rem;
  font-weight: bold;
  margin-bottom: 70px;
  margin-top: 0px !important;
}

.content-wrapper {
  display: flex;
  align-items: stretch; /* 高度对齐 */
  gap: 2.5rem;
  justify-content: center;
  width: 100rem;
  /* margin: 0 auto; */
}

.expert-reviews {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
   gap: 45px;
  font-size: var(--title-font-size);
  text-align: start;
  color: #fff;
  flex: 1.1;
}

.expert-reviews-quote2 {
  align-self: end;
  margin-right: 1.25rem;
}

.famous-doctor {
  height: 10rem;
  background-image: url('../assets/images/clinical/expert-around.png');
  background-size: 100% 100%; /* 图片填满容器，同时保持比例 */
  background-position: center;
  background-repeat: no-repeat;
  font-size: 1.6rem;
  text-align: start;
  color: #00acf8;
  position: relative;
  left: -1rem;
  /* top: 1rem; */
}

/* 左侧 Logo 列表 */
.logo-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 默认两列 */
  row-gap: 2.5rem;
  column-gap: 3.125rem;
  flex: 1;
  background: #fff;
  padding: 2.5rem var(--title-font-size);
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.logo-item img {
  width: 100px;
  height: 100px;
  display: block;
  margin: 0 auto 8px;
}

.logo-item p {
  font-size: 14px;
  color: #333;
  text-align: center;
}

/* 首都医科大学附属安贞医院单独一行 */
.logo-item.single-row {
  grid-column: span 2;
  justify-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 右侧视频卡片 */
.video-card {
  background: #111827;

  border-radius: 14px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  flex: 2;
}

.expert-video {
  width: 100%;
  border-radius: 10px;
  position: relative;
    top: -1rem;
}

.comment {
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
  color: #00acf8;
  font-weight: bolder;
  padding-left: 10px;
  padding-left: 1.25rem;
  margin-top: 5px !important;
}

/* 移动端响应式 */
@media (max-width: 768px) {
  .logo-list {
    grid-template-columns: 1fr; /* 单列显示 */
  }
  .logo-item.single-row {
    grid-column: span 1; /* 不再占两列 */
  }
}
.case-analysis {
  background-color: black;
  width: 65%;
  margin: auto;
  color: #fff;
  text-align: center;

  padding: 7.5rem 0px;
}

/* 固定宽度容器并居中 */
.image-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  margin: 0 auto 3.75rem; /* 下方间距 */

  flex-direction: row;
}

.image-section.reverse {
  flex-direction: row-reverse;
}

.image-section img {
  width: 45%;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.caption {
  width: 45%;
  font-size: var(--subtitle-font-size);
  color: #ccc;
  text-align: left;
}
.case-title {
  color: #00acf8;
  display: block;
  margin-top: 0px !important;
  margin-bottom: 3.75rem;

  font-size: 24px;
}
.image-section img,
.image-section .caption {
  opacity: 0; /* 初始隐藏 */
}
.expert-image {
  flex: 1;
      background: black;
    border-radius: 20px;
    display: flex
;
}
.video-text-header {
  font-size: var(--title-big-font-size) !important;
  margin-bottom: 1.9rem;
  margin-top: 0px;
  text-align: center;
  font-weight: 800;
}
.video-text-desc {
  font-size: var(--subtitle-font-size);
  margin-bottom: 0.9rem;
  text-align: center;
  font-weight: 400;
  color: #adafaf;
}

.result-card .group p,
.result-card .value p,
.result-card .rate p {
  /* 固定高度：两行文字 */
  height: 43px; /* 2 行 * 1.25rem 行高 */
  line-height: 1.25rem;
  padding-left: 10px;
  /* 两行截断 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 关键：用 flex 包装 + 居中 */
  display: flex;
  align-items: center; /* 垂直居中 */
  font-size: var(--subThirdtitle-font-size);
}
.result-card .group div,
.result-card .value div,
.result-card .rate div {
  /* 固定高度：两行文字 */
  height: 43px; /* 2 行 * 1.25rem 行高 */
  line-height: 1.25rem;

  /* 两行截断 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  /* 关键：用 flex 包装 + 居中 */
  display: flex;
  align-items: center; /* 垂直居中 */
  font-size: var(--subThirdtitle-font-size);
  padding-left: 5px;
}

@media (max-width: 1300px) {
  .famous-doctor-text {
    top: 1.2rem;
  }
}

@media (max-width: 768px) {
  .video {
    align-items: start;
  }
  .video-text {
    position: absolute;
    top: auto;
    bottom: 5rem;
    z-index: 999;
  }
  .video-text-header {
    width: 88%;

    margin: 0 auto;
    margin-bottom: 1rem !important;
    font-size: 3rem !important;
    text-align: left;
  }
  .video-text-desc {
    width: 88%;
    margin: 0 auto !important;
    text-align: left;
  }
  .clinical-results {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .title-header {
    font-size: 3rem;
    text-align: left;
    padding: 0rem 20px 0;
    /* word-break: break-all; */
    margin-bottom: 2rem;
  }
  .title {
    width: 98vw;
    margin-bottom: 2rem;
  }
  .card-container-efficacy {
    width: 90%; /* 屏幕小于 1300px 时自适应 */
  }
  .card-container-efficacy-data {
    order: 2;
    gap: 2rem;
  }
  .card-container-efficacy {
    flex-direction: column;
    gap: 2rem;
  }
  .image-wrapper img {
    height: auto !important;
  }
  .expert-section {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .expert-title {
    padding-bottom: 2rem;
    width: calc(100vw - 50px);
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
  }
  .content-wrapper {
    width: 90%; /* 屏幕小于 1300px 时自适应 */
  }
  .content-wrapper {
    flex-direction: column; /* ✅ 让子元素上下排列 */
  }
  .expert-reviews-image {
    width: 2rem;
    height: 2rem;
  }
  .expert-reviews-text {
    padding: 2rem 0px;
  }
  .famous-doctor {
    background-image: url('../assets/images/clinical/wordBg-mobile.png');
    height: 13rem; /* 可选：移动端高度略调 */
    left: 0; /* 也可以顺便优化位置 */
    top: 2rem;
  }
  .famous-doctor-text {
    top: 2rem;
    left: 1rem;
    width: 95%;
  }
  .result-card {
    padding: 1.2rem 1.2rem;
  }
  .result-card h3 {
    margin-bottom: 10px;
    min-height: auto;
  }
  .expert-reviews{
    gap:0px;
  }
}

@media (min-width: 768px) and (max-width: 1000px) {
  .card-container-efficacy {
    transform: scale(0.65);
  }
  .content-wrapper {
    transform: scale(0.65);
  }
}

@media (min-width: 1000px) and (max-width: 1600px) {
  /* 这里写在 768px ~ 1600px 之间生效的样式 */
  .card-container-efficacy {
    transform: scale(0.8);
  }
  .content-wrapper {
    transform: scale(0.8);
  }
  /* .famous-doctor {
    height: 12rem;
  } */
}
</style>
